import { useDisclosure } from "@mantine/hooks";
import {
  Drawer,
  Button,
  ScrollArea,
  Box,
  createStyles,
  Text,
  Divider,
  Avatar,
  Accordion,
  Select,
  Center,
  ActionIcon,
  Checkbox,
  TextInput,
  Group,
  Badge,
  PasswordInput,
  Modal,
  Table,
  Paper,
} from "@mantine/core";
import { useEffect, useState } from "react";
import {
  IconChevronDown,
  IconDots,
  IconSearch,
  IconTrash,
} from "@tabler/icons-react";
import SearchBar from "../Document/searchBar";
import { useSelector } from "react-redux";
import {
  addPatient,
  editPatient,
  getAllPatients,
  getAllPatientsModal,
} from "../../services/patient";
import BillingSearchBar from "../Document/BillingSearchBar";
import { DateInput, DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { decrypt, encrypt, showError } from "../../utils";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { getelibilitystatus } from "../../services";
import { debounce } from "lodash";
import { stateZipCodes } from "../../utils/zipCodes";
import { getdiagnosiscode } from "../../services/servicecode";
import CheckEligibilty from "./CheckEligibilty";
import ProviderServicesLookupModal from "./providerServicesLookupModal";
import { getpayer } from "../../services/payer";

const useStyles = createStyles(() => ({
  mainbox: {
    background: " #F5F5F5",
    padding: "13px 19px",
  },

  addbox: {
    // padding: "12px 12px 20px 30px",
    padding: "20px 15px",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
  },

  newinputbox: {
    background: "#FFF !important",
    border: "1px solid #E5E5E5 !important",
    borderRadius: "8px !important",
    width: "79px !important",
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    color: "#000 !important",
    textAlign: "center !important",
    justifyContent: "center !important",
    alignSelf: "center !important",
    alignItems: "center !important",

    ".mantine-1vlckrq": {
      textAlign: "center",
      fontFamily: "Inter !important",
      fontSize: "14px !important",
      fontWeight: "400 !important",
      color: "#000 !important",
    },
    ".mantine-6kqrk6": {
      textAlign: "center",
    },
  },

  formRow: {
    width: "100%",
    display: "flex",
    // justifyContent: "space-between",
    gap: "18px",
    marginBottom: "20px",
    "@media (max-width:1300px)": {
      flexDirection: "column",
      gap: "10px",
    },

    mt: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },
  },

  addbtn: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "20px",
    marginTop: "10%",
  },
  lookupflex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  minitags: {
    borderRadius: "16px",
    background: "#F2F4F7",
    padding: "4px 10px 4px 12px",
    width: "max-content",
    display: "flex",
    gap: "4px",
    flexDirection: "row",
    // height:'28px'
  },

  maintags: {
    marginTop: "19px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "20px",
  },

  container: {
    display: "flex",
    flexDirection: "column",
    // gap: "6px",
    width: "100%",
  },
  boxWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
    padding: "5px 15px",
    backgroundColor: "#fff",
    width: "100%",
  },
  selectBilling: {
    width: "65px",
    minWidth: "65px",
    fontSize: "14px",
  },

  tableheader: {
    fontSize: "14px !important",
    fontWeight: "700 !important",
    color: "#000 !important",
  },

  inputField: {
    flex: 1,
    fontSize: "14px",
    border: "none",
    padding: "0",
  },

  table: {
    // borderRadius: "8px",
    // border: "1px solid #E5E5E5",
    background: "#FFF",
    padding: "12px 0px",
  },

  datepickerinput: {
    width: "100%",
    padding: "10px 14px",
    borderRadius: "8px",
    border: "1px solid  #D0D5DD",
    // height:'49px',
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",

    backgroundColor: bgColor,
  },

  selectnumber: {
    width: "70px",
    padding: "5px 5px",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  fullw: {
    width: "100% !important",
  },

  selecttext: {
    width: "120px",
    padding: "5px 15px",

    backgroundColor: bgColor,
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  widthbox: {
    width: "100%",
  },

  stepsclient: {
    borderRadius: "8px",
    background: "#FFF",
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 16px 0px 16px",
    marginTop: "28px",
    marginBottom: "28px",
    "@media (max-width:1370px)": {
      flexDirection: "column",
      gap: "10px",
    },
  },

  date: {
    width: "100%",
    backgroundColor: bgColor,
    margin: "auto",
  },

  dateBgChange: {
    borderRadius: "5px",
    padding: "5px 15px",
    "& input": {
      backgroundColor: "transparent",
      fontSize: "0.875rem",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    // width:'300px'
    // width: "min-content"
    // justifyContent:'flex-end'
  },

  gap: {
    display: "flex",
    gap: "8px",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "19px",
  },

  dbtnflex: {
    display: "flex",
    // justifyContent: "space-between",
    flexDirection: "row",
    // justifyContent: "space-between",
    justifyContent: "flex-end",
    gap: "20px",
    // justifyContent: "flex-end",

    "@media (max-width:950px)": {
      flexDirection: "column",
      marginBottom: "20px",
      marginTop: "20px",
      gap: "10px",
    },
  },

  dflex: {
    display: "flex",
    // justifyContent: "space-between",
    flexDirection: "row",
    // justifyContent: "space-between",
    // gap: "20px",
    gap: "16px",
    // justifyContent: "flex-end",

    "@media (max-width:950px)": {
      flexDirection: "column",
      marginBottom: "20px",
      marginTop: "20px",
      gap: "10px",
    },
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  // searchbox: {
  //   marginTop: "50px",
  //   marginBottom: "50px",
  // },

  searchbox: {
    // marginTop: "20px",
    marginBottom: "24px",
  },

  backNextBtn: {
    marginTop: "30px",
    marginBottom: "30px",
    "@media (max-width:950px)": {
      marginBottom: "10px",
      marginTop: "10px",
    },
    "&:hover": {
      background: "#FFAF4A",
      color: "#FFFFFF",
      opacity: 0.8,
    },
  },

  button: {
    "&:hover": {
      background: "#FFAF4A",
      color: "#FFFFFF",
      opacity: 0.8,
    },
  },
}));

// const bgColor = "#D9D9D9";

const bgColor = "#FFFFFF";

const CustomTextInput = ({ ...rest }) => {
  // const useStyles = createStyles((theme) => ({
  //   textInputBox: {
  //     width: "100%",
  //     padding: "5px 15px",
  //     borderRadius: "5px",
  //     backgroundColor: bgColor,
  //     "& input": {
  //       backgroundColor: "transparent",
  //       border: "none",
  //       paddingInline: 0,
  //     },
  //   },
  // }));
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "10px 14px",
      borderRadius: "8px",
      height: "44px",
      border: "1px solid #E5E5E5",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  // const useStyles = createStyles((theme) => ({
  //   textInputBox: {
  //     width: "100%",
  //     padding: "5px 11px",
  //     borderRadius: "5px",
  //     backgroundColor: bgColor,
  //     "& input": {
  //       border: "none",
  //       paddingInline: 0,
  //       backgroundColor: "transparent",
  //     },
  //   },
  // }));

  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",

      backgroundColor: bgColor,
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#94A3B8"} size={25} />}
        rightSectionWidth={30}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

function EditClient({
  editclient,
  setEditclient,
  patient,
  isPreview,
  // selectedProvider,
  selectedPayers,
  setSelectedPayers,
}) {
  // console.log("patient here", patient);

  // console.log('selectedProvider',selectedProvider);
  const { allpayer } = useSelector((state) => state.payer);

  useEffect(() => {
    getpayer();
  }, []);

  const [openlookup, setOpenLookup] = useState(false);

  const { classes } = useStyles();
  const [currentStep, setCurrentStep] = useState(0);

  const [selectedProvider, setselectedProvider] = useState(null);

  const [provider, setProvider] = useState(null);

  // console.log('selectedProvider.services',selectedProvider?.services);

  // console.log('provider',provider);
  // console.log('isPreview',isPreview);


  const [facility, setFacility] = useState(
    patient?.selectedClient?.facilityId || []
  );
  const [payer, setPayer] = useState(null);
  const [services, setServices] = useState(null);
  const [servicesinfo, setServicesinfo] = useState(
    // patient?.selectedClient?.form1?.services || []
    patient?.form1?.services || []
  );

  const addService = () => {
    if (
      !services ||
      !services.servicechargeAmount ||
      !services.servicechargeNumber ||
      !services.servicechargetype ||
      !services.servicenumber ||
      !services.servicetitle ||
      !services.totalCharge
    ) {
      showError("Missing or empty fields", 400);
      return;
    }
    if (services) {
      setServicesinfo((prevServicesinfo) => [...prevServicesinfo, services]);
      setServices(null);
    }
  };

  const [diagnosis, setDiagnosis] = useState(
    // patient?.selectedClient?.form1?.diagnosis || []
    patient?.form1?.diagnosis || []
  );
  // console.log('diagnosis here',diagnosis);

  const [diagnosisField, setDiagnosisField] = useState({
    code: "",
    name: "",
  });

  const handleChangeDiagnosis = () => {
    if (!diagnosisField.code || !diagnosisField.name) {
      showError("Missing or empty fields", 400);
      return;
    }
    const newDiagnosis = {
      code: diagnosisField.code,
      name: diagnosisField.name,
    };

    setDiagnosis((prevDiagnosis) => [...prevDiagnosis, newDiagnosis]);

    // Clear the diagnosisField after adding
    setDiagnosisField({
      code: "",
      name: "",
    });
  };

  const removeDiagnosis = (index) => {
    let temp = diagnosis?.filter((_, i) => i !== index);
    setDiagnosis(temp);
  };

  const removeServices = async (index) => {
    const willDelete = await swal({
      title: `Are you sure want to delete this service?`,
      text: "",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) {
      let temp = servicesinfo?.filter((_, i) => i !== index);
      setServicesinfo(temp);
    }
  };

  const handleChange = (name, value) => {
    setDiagnosisField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleServiceChange = (value) => {
    // const selectedService = provider?.services?.find(service => service.servicetitle === value);
    setServices(value);
  };

  const handleServiceFieldChange = (field, value) => {
    // const numericValue = isNaN(value) ? 0 : Number(value); // Ensure the value is a valid number

    setServices((prevServices) => {
      const updatedServices = {
        ...prevServices,
        [field]: value,
      };

      // Calculate the total if both servicechargeNumber and servicechargeAmount are set
      if (
        updatedServices.servicechargeNumber &&
        updatedServices.servicechargeAmount
      ) {
        updatedServices.totalCharge =
          updatedServices.servicechargeNumber *
          updatedServices.servicechargeAmount;
      }

      return updatedServices;
    });
  };

  const allfacilty = useSelector((state) => state.facility);
  const eligibilitystatus = useSelector(
    (state) => state?.billing?.eligibilitystatus
  );
  // console.log('eligibilitystatus',eligibilitystatus);

  const allbillingprovider = useSelector(
    (state) => state.billingprovider?.allbillingprovider
  );
  const [diagnosisSearchValue, setDiagnosisSearchValue] = useState("");

  // console.log('allfacilty?.allFacilities?.facilities',allfacilty?.allFacilities?.facilities[0]);

  const alldiagnosiscode = useSelector(
    (state) => state.servicecode.alldiagnosisCode
  );

  const [insuranceData, setInsuranceData] = useState({
    // firstName: patient?.selectedClient?.form2?.insurance?.[0]?.firstName || "",
    // middleName:
    //   patient?.selectedClient?.form2?.insurance?.[0]?.middleName || "",
    // lastName: patient?.selectedClient?.form2?.insurance?.[0]?.lastName || "",
    // address1: patient?.selectedClient?.form2?.insurance?.[0]?.address1 || "",
    // address2: patient?.selectedClient?.form2?.insurance?.[0]?.address2 || "",
    // city: patient?.selectedClient?.form2?.insurance?.[0]?.city || "",
    // state: patient?.selectedClient?.form2?.insurance?.[0]?.state || "",
    // zipCode: patient?.selectedClient?.form2?.insurance?.[0]?.zipCode || "",
    // identificationNumber:
    //   patient?.selectedClient?.form2?.insurance?.[0]?.identificationNumber ||
    //   "",
    // groupPolicyNumber:
    //   patient?.selectedClient?.form2?.insurance?.[0]?.groupPolicyNumber || "",
    // dob: patient?.selectedClient?.form2?.insurance?.[0]?.dob || "",
    // gender: patient?.selectedClient?.form2?.insurance?.[0]?.gender || "",
    // relationshipToInsured:
    //   patient?.selectedClient?.form2?.insurance?.[0]?.relationshipToInsured ||
    //   "",
    //   payer:patient?.selectedClient?.form2?.insurance?.[0]?.payer.id ||
    //   "",

    firstName: patient?.form2?.BillingInsurance?.[0]?.firstName || "",
    middleName: patient?.form2?.BillingInsurance?.[0]?.middleName || "",
    lastName: patient?.form2?.BillingInsurance?.[0]?.lastName || "",
    address1: patient?.form2?.BillingInsurance?.[0]?.address1 || "",
    address2: patient?.form2?.BillingInsurance?.[0]?.address2 || "",
    city: patient?.form2?.BillingInsurance?.[0]?.city || "",
    state: patient?.form2?.BillingInsurance?.[0]?.state || "",
    zipCode: patient?.form2?.BillingInsurance?.[0]?.zipCode || "",
    identificationNumber:
      patient?.form2?.BillingInsurance?.[0]?.identificationNumber || "",
    groupPolicyNumber:
      patient?.form2?.BillingInsurance?.[0]?.groupPolicyNumber || "",
    dob: patient?.form2?.BillingInsurance?.[0]?.dob || "",
    gender: patient?.form2?.BillingInsurance?.[0]?.gender || "",
    relationshipToInsured:
      patient?.form2?.BillingInsurance?.[0]?.relationshipToInsured || "",
    payer: patient?.form2?.BillingInsurance?.[0]?.payer || null,
    authorization: patient?.form2?.BillingInsurance?.[0]?.authorization || "",
    authorizationEndDate:
      patient?.form2?.BillingInsurance?.[0]?.authorizationEndDate || "",
  });

  //  console.log("insuranceData", insuranceData);

  const [insuranceArray, setInsuranceArray] = useState(
    // patient?.selectedClient?.form2?.insurance || []
    patient?.form2?.BillingInsurance || []
  );

  //  console.log("insuranceArray", insuranceArray);

  const handleClose = () => {
    // setIsPreview(false);
    setCurrentStep(0);
    setEditclient(false);
  };

  const handleInsuranceChange = (id, value) => {
    setInsuranceData((prevData) => {
      const updatedData = {
        ...prevData,
        [id]: value,
      };

      if (insuranceArray.length > 0) {
        setInsuranceArray([updatedData]);
        console.log("Insurance data updated:", updatedData);
      } else {
        setInsuranceArray([updatedData]);
        console.log("New insurance data added:", updatedData);
      }

      return updatedData;
    });
  };

  const updatestate = (step) => {
    setCurrentStep(step);
  };

  console.log("servicesinfo", servicesinfo);

  // console.log('pateintitem',patient);

  const form = useForm({
    initialValues: {
      firstName: "",
      lastName: "",
      middleName: "",
      height: "",
      weight: "",
      gender: "",
      dob: new Date(),
      previousAddress: "",
      address: "",
      previousAddress2: "",
      socialSecurityNumber: "",
      lastFourDigits: "",
      dietaryRestrictions: "",
      contagious: "no",
      patientWounds: "no",
      isKnownIllness: "no",
      zipCode: "",
      state: "",
      city: "",
      phone: "",
      admissionDate: new Date(),

   insurancefirstName: "",
      insurancemiddleName:"",
      insurancelastName: "",
      insuranceaddress1: "",
      insuranceaddress2: "",
      insurancecity: "",
      insurancestate: "",
      insurancezipCode: "",
      insuranceidentificationNumber: "",
      insurancegroupPolicyNumber: "",
      insurancedob: new Date(),
      insurancegender: "",
      insurancerelationshipToInsured: "",
      insuranceauthorization: "",
      insuranceauthorizationEndDate: new Date(),
      insurancepayer: {},

      dietaries: [],
      dnrCode: "",
      isForm1: "",
      knownAllergies: [],
      knownIllness: [],
      levelofcare: "",
      personalPreference: "",
      summary: "",
    },
    validate: {
      // firstName: (value) => (value ? null : "Required"),
      // dob: (value) => (value ? null : "Required"),
      // previousAddress: (value) => (value ? null : "Required"),
      // // facility: (value) => (value ? null : "Required")
      // //   knownAllergies: (value) => (value ? null : "Required")
      // //   dietaryRestrictions: (value) => (value ? null : "Required")
    },
  });

  useEffect(() => {
    if (patient) {
const billingInsurance =
    Array.isArray(patient?.form2?.BillingInsurance) && patient.form2.BillingInsurance.length > 0
      ? patient.form2.BillingInsurance[0]
      : null;

      form.setValues({
        firstName: patient?.form1?.firstName || "",
        lastName: patient?.form1?.lastName || "",
        middleName: patient?.form1?.middleName || "",
        gender: patient?.form1?.gender || "",
        address: patient.form1?.address || "",
        dietaries: patient.form1?.dietaries || [],
        //  dob: patient?.form1?.dob || "",
         dob: patient?.form1?.dob ? new Date(patient?.form1?.dob) : null,
        // dob: patient?.form1?.dob ? formatDate(patient.form1.dob) : "",
        knownAllergies: patient?.form1?.knownAllergies || [],
        previousAddress: patient?.form1?.previousAddress || "",
        previousAddress2: patient?.form1?.previousAddress2 || "",
        socialSecurityNumber:
          decrypt(patient?.form1?.socialSecurityNumber, false) || "",
        lastFourDigits: patient?.form1?.lastFourDigits || "",
        dietaryRestrictions: patient?.form1?.dietaryRestrictions || "",
        knownIllness: patient?.form1?.knownIllness || [],
        isForm1: patient?.form1?.isForm1 || false,
        dnrCode: patient?.form1?.dnrCode || "",
        levelofcare: patient?.form1?.levelofcare || "",
        contagious: patient?.form1?.contagious || "no",
        patientWounds: patient?.form1?.patientWounds || "no",
        isKnownIllness: patient?.form1?.isKnownIllness || "no",
        zipCode: patient?.form1?.zipCode || "",
        state: patient?.form1?.state || "",
        city: patient?.form1?.city || "",
        phone: patient?.form1?.phone || "",
        height: patient?.form1?.height || "",
        admissionDate: patient?.form1?.admissionDate || "",
        personalPreference: patient?.form1?.personalPreference || "",
        weight: patient?.form1?.weight || "",
        summary: patient?.form1?.summary || "",

  // Insurance fields using billingInsurance or fallback
    insurancefirstName: billingInsurance?.firstName || patient?.form1?.firstName || "",
    insurancemiddleName: billingInsurance?.middleName || patient?.form1?.middleName || "",
    insurancelastName: billingInsurance?.lastName || patient?.form1?.lastName || "",
    insuranceaddress1: billingInsurance?.address1 || patient?.form1?.previousAddress || "",
    insuranceaddress2: billingInsurance?.address2 || patient?.form1?.previousAddress2 || "",
    insurancecity: billingInsurance?.city || patient?.form1?.city || "",
    insurancestate: billingInsurance?.state || patient?.form1?.state || "",
    insurancezipCode: billingInsurance?.zipCode || patient?.form1?.zipCode || "",
    insuranceidentificationNumber: billingInsurance?.identificationNumber || "",
    insurancegroupPolicyNumber: billingInsurance?.groupPolicyNumber || "",
    insurancedob: billingInsurance?.dob
      ? new Date(billingInsurance.dob)
      : patient?.form1?.dob
        ? new Date(patient.form1.dob)
        : null,
    insurancegender: billingInsurance?.gender || patient?.form1?.gender || "",
    insurancerelationshipToInsured: billingInsurance?.relationshipToInsured || "",
    insurancepayer: billingInsurance?.payer || "",
    insuranceauthorization: billingInsurance?.authorization || "",
    insuranceauthorizationEndDate: billingInsurance?.authorizationEndDate
      ? new Date(billingInsurance.authorizationEndDate)
      : null,
     
        // admissionDate: patient?.selectedClient?.form1?.admissionDate || '',
      });

      console.log("patient?.form1", patient);

      // if (patient?.form2?.BillingInsurance?.[0]) {
      //   setInsuranceData({
      //     firstName: patient.form2.BillingInsurance[0].firstName || "",
      //     middleName: patient.form2.BillingInsurance[0].middleName || "",
      //     lastName: patient.form2.BillingInsurance[0].lastName || "",
      //     address1: patient.form2.BillingInsurance[0].address1 || "",
      //     address2: patient.form2.BillingInsurance[0].address2 || "",
      //     city: patient.form2.BillingInsurance[0].city || "",
      //     state: patient.form2.BillingInsurance[0].state || "",
      //     zipCode: patient.form2.BillingInsurance[0].zipCode || "",
      //     identificationNumber:
      //       patient.form2.BillingInsurance[0].identificationNumber || "",
      //     groupPolicyNumber:
      //       patient.form2.BillingInsurance[0].groupPolicyNumber || "",
      //     // dob: patient.form2.BillingInsurance[0].dob || "",

      //     dob: patient?.form2?.BillingInsurance[0]?.dob
      //       ? new Date(patient.form2.BillingInsurance[0].dob)
      //       : null,
      //     gender: patient.form2.BillingInsurance[0].gender || "",
      //     relationshipToInsured:
      //       patient.form2.BillingInsurance[0].relationshipToInsured || "",

      //     payer: patient.form2.BillingInsurance[0].payer || "",
      //     authorization:
      //       patient?.form2?.BillingInsurance?.[0]?.authorization || "",
      //     // authorizationEndDate:patient?.form2?.BillingInsurance?.[0]?.authorizationEndDate || "",
      //     authorizationEndDate: patient?.form2.BillingInsurance[0]
      //       .authorizationEndDate
      //       ? new Date(patient.form2.BillingInsurance[0].authorizationEndDate)
      //       : null,
      //   });

      //   setInsuranceArray(patient?.form2?.BillingInsurance);
      // }

      // setProvider(selectedProvider || null);
      setselectedProvider(patient?.providerId[0] || null);
      setProvider(patient?.providerId[0]?.id || null);
      // setFacility(patient?.selectedClient?.facilityId || []);
      setFacility(patient?.facilityId || []);
      setPayer(patient?.payer || null);
      setDiagnosis(patient.form1.diagnosis || []);
      setServicesinfo(patient.form1.services || []);
    }
  }, [patient]);

  const DEBOUNCE_DELAY = 500;

  // console.log("form", form);
  // console.log("selectedProvider.services", selectedProvider);

  // console.log('insuranceArray',insuranceArray);

  const fetchEligibilityStatus = async (payload) => {
    // try {
    //   await getelibilitystatus(payload);
    // } catch (error) {
    //   console.error("Error fetching eligibility status:", error);
    // }
  };

  useEffect(() => {
    if (
      form.values.lastName === "" ||
      form.values.firstName === "" ||
      !patient ||
      !selectedProvider ||
      !selectedProvider?.billingIdentifier?.number
    )
      return;

    const payload = {
      ins_name_l: form.values.lastName || "",
      ins_name_f: form.values.firstName || "",
      payerid: patient.payer,
      pat_rel: insuranceData?.relationshipToInsured || "18",
      fdos: "2022-10-13",
      prov_npi: selectedProvider?.billingIdentifier?.number,
      prov_taxid: selectedProvider?.taxonomy,
    };

    const debouncedFetchEligibilityStatus = debounce((payload) => {
      fetchEligibilityStatus(payload);
    }, DEBOUNCE_DELAY);

    debouncedFetchEligibilityStatus(payload);

    return () => {
      debouncedFetchEligibilityStatus.cancel();
    };
  }, [
    form.values.firstName,
    form.values.lastName,
    patient,
    selectedProvider,
    insuranceData?.relationshipToInsured,
  ]);

  const onSave = async (_) => {
    try {
      const values = form.values;
      let missingFields = [];
      Object.entries(values)
        .filter(
          ([key, _]) =>
            key !== "previousAddress2" &&
            key !=="insuranceaddress2"&&
            key !== "socialSecurityNumber" &&
            key !== "lastFourDigits" &&
            key !== "dietaryRestrictions" &&
            key !== "address" &&
            key !== "weight" &&
            key !== "height" &&
            key !== "admissionDate" &&
            key !== "dnrCode" &&
            key !== "isForm1" &&
            key !== "levelofcare" &&
            key !== "personalPreference" &&
            key !== "summary" &&
            key !== "middleName"&&
            key !=="insurancegroupPolicyNumber"&&
            key !=="insurancemiddleName"
        )

        .forEach(([key, value]) => !value && missingFields.push(key));
      if (facility?.length < 1) missingFields.push("Facility");
      if (!provider) missingFields.push("provider");
      if (servicesinfo.length < 1) missingFields.push("Service");
      if (diagnosis.length < 1) missingFields.push("Dygnosis");
      // if (insuranceArray.length < 1) {
      //   missingFields.push("insurance missing");
      // } else {
      //   const insurance = insuranceArray[0];

      //   if (insurance) {
      //     Object.keys(insurance).forEach((key) => {
      //       if (
      //         key !== "address2" &&
      //         key !== "middleName" &&
      //         key !== "groupPolicyNumber"
      //       ) {
      //         console.log("*****ins missing", insurance[key]);
      //         if (!insurance[key]) {
      //           missingFields.push(`Field ${key} is missing in insurance`);
      //         }
      //       }
      //     });
      //   } else {
      //     missingFields.push("Fields is missing in insurance");
      //   }
      // }

      if (missingFields.length > 0) {
        await swal({
          title: "Please fill out the following fields",
          text: missingFields.join(", "),
          icon: "warning",
          dangerMode: true,
        });
        missingFields = [];
        return;
      }

      const selectedState = values.state?.trim();
      const enteredZipCode = values.zipCode?.trim();
         const insuranceselectedState = values.insurancestate?.trim();
      const insuranceenteredZipCode = values.insurancezipCode?.trim();
      if (selectedState && enteredZipCode) {
        const stateZipCodeEntries = stateZipCodes.filter(
          (entry) => entry.ste_name === selectedState
        );

        const isZipValid = stateZipCodeEntries.some(
          (entry) => entry.zip_code === enteredZipCode
        );

        if (!isZipValid) {
          await swal({
            title: "Invalid Zip Code",
            text: `The zip code you entered is not valid for ${selectedState}. Please enter a valid zip code.`,
            icon: "warning",
            dangerMode: true,
          });
          return;
        }
      }

      
                if (insuranceselectedState && insuranceenteredZipCode) {
              const stateZipCodeEntries = stateZipCodes.filter(
                (entry) => entry.ste_name === insuranceselectedState
              );
      
              const isZipValid = stateZipCodeEntries.some(
                (entry) => entry.zip_code === insuranceenteredZipCode
              );
      
              if (!isZipValid) {
                await swal({
                  title: "Invalid Zip Code",
                  text: `The zip code you entered is not valid for ${insuranceselectedState}. Please enter a valid zip code.`,
                  icon: "warning",
                  dangerMode: true,
                });
                return;
              }
            }

      const updatePatientData = (newobj) => {
        const updatedPayers = selectedPayers.map((payer) => ({
          ...payer,
          payerId: payer.payerId.map((item) => ({
            ...item,
            patients: item.patients.map((patient) => {
              if (patient.id === newobj.id) {
                const obj = {
                  name: `${newobj?.form1?.firstName} ${newobj?.form1?.lastName}`,
                  form1: newobj.form1,
                  form2: newobj.form2,
                  facilityId: newobj.facilityId,
                  providerId: newobj.providerId,
                  id: newobj.id,
                  form3: newobj.form3,
                };
                return obj;
              }
              return patient;
            }),
          })),
        }));

        setSelectedPayers(updatedPayers);
      };

let finalinsurancearray = [];

finalinsurancearray.push({
  firstName: values.insurancefirstName || "",
  middleName: values.insurancemiddleName || "",
  lastName: values.insurancelastName || "",
  address1: values.insuranceaddress1 || "",
  address2: values.insuranceaddress2 || "",
  city: values.insurancecity || "",
  state: values.insurancestate || "",
  zipCode: values.insurancezipCode || "",
  identificationNumber: values.insuranceidentificationNumber || "",
  groupPolicyNumber: values.insurancegroupPolicyNumber || "",
  dob: values.insurancedob || new Date(),
  gender: values.insurancegender || "",
  relationshipToInsured: values.insurancerelationshipToInsured || "",
  authorization: values.insuranceauthorization || "",
  authorizationEndDate: values.insuranceauthorizationEndDate || "",
  payer: values.insurancepayer || {},
});


      let payload = {
        form1: {
          ...values,
          name: `${values?.firstName} ${values?.lastName}`,
          services: servicesinfo,
          diagnosis,
        },

        form2: {
          ...patient.form2,
          // insurance: [insuranceData],
          // BillingInsurance: [insuranceArray[0]],
          BillingInsurance:finalinsurancearray
        },

        facilityId: facility.map((f) => f?.id),
        providerId: [provider],
        payerId: payer,
        form3: patient.form3,
      };

      let obj = {
        name: `${payload?.form1?.firstName} ${payload?.form1?.lastName}`,
        form1: payload.form1,
        form2: payload.form2,
        facilityId: payload.facilityId,
        providerId: payload.providerId,
        // id: patient?.selectedClient.id,
        id: patient?.id,
        form3: payload?.form3,
      };

      console.log("obj", obj);

      let response = await editPatient(obj,false,1,true);

      if (response.status === 200) {
        // getAllPatientsModal();
        getAllPatients(1, true, true);
        handleClose();
        // getBillingClient();

        if (selectedPayers && selectedPayers.length > 0) {
          updatePatientData(obj);
        }

        swal({
          title: `Client update successfully`,
          text: "Client update successfully",
          dangerMode: false,
        });

        // await getAllFacilitiesModal();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // console.log('patients hrer',allfacilty);

  const nextbtn = () => {
    setDiagnosisField({
      code: "",
      name: "",
    });
    setServices(null);
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Define content for each step
  const renderContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            {/* <Text
              style={{ marginBottom: "9px" }}
              ff={"Inter"}
              fz={14}
              fw={500}
              color="#171717"
            >
              Client Personal Details
            </Text> */}
            <form>
              <div className={classes.formRow}>
                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    First Name *
                  </Text>
                  <CustomTextInput
                    id="first-name"
                    size="sm"
                    withAsterisk
                    {...form.getInputProps("firstName")}
                       onChange={(e) => {
                      form.setFieldValue('firstName', e.target.value)
                      form.setFieldValue('insurancefirstName', e.target.value)
                    }}
                  />
                </Box>
                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Middle Name *
                  </Text>
                  <CustomTextInput
                    id="first-name"
                    size="sm"
                    withAsterisk
                    {...form.getInputProps("middleName")}
                      onChange={(e) => {
                      form.setFieldValue('middleName', e.target.value)
                      form.setFieldValue('insurancemiddleName', e.target.value)
                    }}
                  />
                </Box>

                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Last Name *
                  </Text>
                  <CustomTextInput
                    id="last-name"
                    size="sm"
                    withAsterisk
                    {...form.getInputProps("lastName")}
                       onChange={(e) => {
                      form.setFieldValue('lastName', e.target.value)
                      form.setFieldValue('insurancelastName', e.target.value)
                    }}
                  />
                </Box>
              </div>

              <Box mt={10}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Address 1
                </Text>
                <CustomTextInput
                  id="address1"
                  size="sm"
                  withAsterisk
                  {...form.getInputProps("previousAddress")}
                         onChange={(e) => {
                      form.setFieldValue('previousAddress', e.target.value)
                      form.setFieldValue('insuranceaddress1', e.target.value)
                    }}
                />
              </Box>

              <Box mt={10}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Address 2
                </Text>
                <CustomTextInput
                  id="address2"
                  size="sm"
                  withAsterisk
                  {...form.getInputProps("previousAddress2")}
                     {...form.getInputProps("previousAddress2")}
                            onChange={(e) => {
                      form.setFieldValue('previousAddress2', e.target.value)
                      form.setFieldValue('insuranceaddress2', e.target.value)
                    }}
                />
              </Box>

              <Box style={{ marginTop: "12px" }} className={classes.mt19}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Select Facility
                </Text>
                <CustomSelectBox
                  id="billing-type"
                  // default={"+1"}

                  withAsterisk
                  data={(allfacilty && allfacilty?.allFacilities?.facilities
                    ? allfacilty?.allFacilities?.facilities
                    : []
                  ).map((item) => ({
                    // console.log('item chekc',item)

                    value: item,
                    label: item.name,
                  }))}
                  // disabled={selectedProvider && selectedProvider?.facilityId}
                  value={facility}
                  onChange={(value) =>
                    !facility.find((f) => f?.id === value?.id) &&
                    setFacility([...facility, value])
                  }
                />
                <Box className={classes.maintags}>
                  {facility?.map((value, index) => (
                    <Group key={index} className={classes.minitags}>
                      {/* <Badge color="#344054" radius="xs" size="lg">
                        {value?.name}
                      </Badge> */}

                      <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                        {value?.name}
                      </Text>

                      <img
                        onClick={() =>
                          setFacility(
                            facility.filter((f) => f?.id !== value?.id)
                          )
                        }
                        style={{ width: "12px", cursor: "pointer" }}
                        src={"/assets/images/x.png"}
                        alt="Icon"
                      />

                      {/* <Button
                        className={classes.close}
                        color="red"
                        variant="light"
                        onClick={() =>
                          setFacility(
                            facility.filter((f) => f?.id !== value?.id)
                          )
                        }
                      >
                        Remove
                      </Button> */}
                    </Group>
                  ))}
                </Box>
              </Box>
              <Box style={{ marginTop: "30px" }} className={classes.mt19}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Select Provider
                </Text>
                {/* <CustomTextInput
                  disabled={true}
                  size="sm"
                  value={selectedProvider?.name}
                /> */}
                <CustomSelectBox
                  id="billing-type"
                  // default={"+1"}
                  required
                  withAsterisk
                  data={(allbillingprovider &&
                  allbillingprovider?.billingprovider
                    ? allbillingprovider?.billingprovider
                    : []
                  ).map((item) => ({
                    // console.log('item chekc',item)

                    value: item.id,
                    label: item.name,
                  }))}
                  value={provider}
                  // onChange={(value) => setProvider(value)}
                  onChange={(value) => {
                    const matchedProvider =
                      allbillingprovider?.billingprovider?.find(
                        (provider) => provider.id === value
                      );

                    if (matchedProvider) {
                      setselectedProvider(matchedProvider);
                    }
                    setServices(null);
                    setServicesinfo([]);

                    setProvider(value);
                  }}
                />
              </Box>

              <div style={{ marginTop: "19px" }} className={classes.formRow}>
                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    State
                  </Text>
                  <CustomSelectBox
                    id="state"
                    size="sm"
                    withAsterisk
                    data={Array.from(
                      new Set(stateZipCodes?.map((obj) => obj.ste_name))
                    )
                      ?.sort()
                      ?.map((ste_name) => ({
                        value: ste_name,
                        label: ste_name,
                      }))}
                    {...form.getInputProps("state")}
                        onChange={(value) => {
                    form.setFieldValue('state', value);
                    form.setFieldValue('insurancestate', value); 
                  }}

                    searchable
                  />
                </Box>

                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    City
                  </Text>
                  <CustomTextInput
                    id="city"
                    size="sm"
                    withAsterisk
                    {...form.getInputProps("city")}
                           onChange={(e) => {
                      form.setFieldValue('city', e.target.value)
                      form.setFieldValue('insurancecity', e.target.value)
                    }}
                  />
                </Box>

                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Zip Code
                  </Text>

                  {/* <CustomSelectBox
                    id="zip-code"
                    type="number"
                    size="sm"
                    withAsterisk
                    disabled={!form?.values?.state}
                    data={
                      form?.values?.state
                        ? stateZipCodes
                            ?.filter(
                              (obj) => obj?.ste_name === form?.values?.state
                            )
                            ?.map((obj) => ({
                              value: obj?.zip_code,
                              label: obj?.zip_code,
                            }))
                        : []
                    }
                    {...form.getInputProps("zipCode")}
                    searchable
                  /> */}
                  <CustomTextInput
                    id="zip-code"
                    type="number"
                    // label={"Facility Name"}
                    {...form.getInputProps("zipCode")}
                           onChange={(e) => {
                      form.setFieldValue('zipCode', e.target.value)
                      form.setFieldValue('insurancezipCode', e.target.value)
                    }}
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                  />
                </Box>
              </div>

              <div className={classes.formRow}>
                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Gender
                  </Text>
                  <CustomSelectBox
                    id="gender"
                    placeholder="Select"
                    withAsterisk
                    data={[
                      { value: "Male", label: "male" },
                      { value: "Female", label: "female" },
                    ]}
                    {...form.getInputProps("gender")}
                         onChange={(value) => {
                      form.setFieldValue('gender',value)
                      form.setFieldValue('insurancegender',value)
                    }}
                  />
                </Box>

                {/* <Box>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Phone Number
                  </Text>

                  <Box className={classes.boxnumber}>
                    <Select
                      id="billing-type"
                      className={classes.selectnumber}
                      value={"+1"}
                      withAsterisk
                      disabled
                      data={[
                        { value: "+1", label: "+1" },
                        // { value: "+2", label: "+2" },
                      ]}
                      onChange={(value) =>
                        form.setFieldValue(
                          "phone",
                          value + form?.values?.phone?.slice(2)
                        )
                      }
                    />

                    <Box className={classes.line}></Box>
                    <TextInput
                      className={classes.selecttext}
                      id="billing-name"
                      type="number"
                      size="sm"
                      placeholder={"Number"}
                      withAsterisk
                      onChange={(e) =>
                        form.setFieldValue(
                          "phone",
                          form.values?.phone?.substring(0, 2) + e.target.value
                        )
                      }
                      {...form.getInputProps("phone")}
                    />
                  </Box>
                </Box> */}

                <Box className={classes.container}>
                  <Text ff="Inter" fz={14} fw={500} color="#344054">
                    Phone Number
                  </Text>

                  <Box className={classes.boxWrapper}>
                    <Select
                      className={classes.selectBilling}
                      rightSection={
                        <IconChevronDown color={"#94A3B8"} size={20} />
                      }
                      id="billing-type"
                      placeholder="Type"
                      withAsterisk
                      variant="unstyled"
                      value={"+1"}
                      readOnly
                      data={[{ value: "+1", label: "+1" }]}
                      onChange={(value) =>
                        form.setFieldValue(
                          "phone",
                          value + form?.values?.phone?.slice(2)
                        )
                      }
                    />

                    <TextInput
                      className={classes.inputField}
                      id="billing-name"
                      type="text"
                      size="sm"
                      placeholder="000-000-000"
                      withAsterisk
                      variant="unstyled"
                      onChange={(e) =>
                        form.setFieldValue(
                          "phone",
                          form.values?.phone?.substring(0, 2) + e.target.value
                        )
                      }
                      {...form.getInputProps("phone")}
                    />
                  </Box>
                </Box>

                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    DOB
                  </Text>
                  {/* <CustomTextInput id="dob" size="sm" withAsterisk /> */}
                  {/* <CustomTextInput
                    id="city"
                    size="sm"
                    withAsterisk
                    {...form.getInputProps("dob")}
                  /> */}

                  <DatePickerInput
                    id="dob"
                    defaultDate={Date.now()}

                    className={classes.datepickerinput}
                    // defaultValue={new Date()}
                    // size="xl"
                    placeholder="mm/dd/yyyy"
                    sx={{
                      "& .mantine-1e6hn20": {
                        border: "none",
                        minHeight: "fit-content !important",
                      },

                      "& .mantine-1d4lrir": {
                        border: "none !important",
                      },
                    }}
                    icon={
                      <img
                        style={{ width: "20px" }}
                        src={"/assets/images/billingcalendar.png"}
                        alt="Icon"
                      />
                    }
                    styles={{ rightSection: { pointerEvents: "none" } }}
                    {...form.getInputProps("dob")}
                          {...form.getInputProps("dob")}
                      onChange={(value) => {
                      form.setFieldValue('dob',value)
                      form.setFieldValue('insurancedob',value)
                    }}
                  />
                </Box>
              </div>
            </form>
          </>
        );

      case 1:
        return (
          <>
            {/* <Text
              style={{ marginBottom: "9px" }}
              ff={"Inter"}
              fz={12}
              fw={500}
              color="#000"
            >
              Client Service Details
            </Text> */}

            <Box className={classes.searchbox}>
              {/* <Select
                icon={<IconSearch size={25} />}
                placeholder="Search service name..."
                data={(selectedProvider && selectedProvider.services
                  ? selectedProvider.services
                  : []
                ).map((item) => ({
                  value: item,
                  label: item?.servicetitle,
                }))}
                onChange={(value) => {
                  handleServiceChange(value);
                }}
              /> */}

              <Select
                icon={<IconSearch size={25} />}
                // style={{borderRadius:'8px',border:'1px solid #D0D5DD'}}
                sx={{
                  ".mantine-1qj7q0z": {
                    display: "none",
                  },
                }}
                placeholder="Search Service, Service Title"
                data={
                  selectedProvider && selectedProvider.services
                    ? selectedProvider.services
                        .filter((item) => {
                          return !servicesinfo.some(
                            (service) =>
                              service.servicetitle === item.servicetitle &&
                              service.servicenumber === item.servicenumber
                          );
                        })
                        .map((item) => ({
                          value: item,
                          label: item?.servicetitle,
                        }))
                    : []
                }
                onChange={(value) => {
                  handleServiceChange(value);
                }}
              />
            </Box>
            <Box className={classes.dflex}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Service Title
                </Text>

                <CustomTextInput
                  value={services?.servicetitle || ""}
                  readOnly
                  size="sm"
                  onChange={(value) =>
                    handleServiceChange("servicetitle", value)
                  }
                />

                {/* <CustomSelectBox
      size="sm"
      data={(provider && provider.services
        ? provider.services
        : []
      ).map((item) => ({
        value: item,
        label: item?.servicetitle,
      }))}
      onChange={(value) => handleServiceChange(value)}
      //  onChange={(value) => setServices(value)}
      // value={serviceInfo.servicetitle}
      // onChange={(value) => handleServiceChange("servicetitle", value)}

      // onChange()
    /> */}
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Service Code
                </Text>
                <CustomTextInput
                  value={services?.servicenumber || ""}
                  onChange={(e) =>
                    handleServiceFieldChange("servicenumber", e.target.value)
                  }
                  readOnly
                  // value={serviceInfo.servicenumber}
                  // onChange={(e) => handleServiceChange("servicenumber", e.target.value)}

                  size="sm"
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Approved
                </Text>

                {/* <CustomSelectBox
      id="billing-type"
      // default={"+1"}
      placeholder={"Select"}
      withAsterisk
      data={[
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ]}
      onChange={(value) =>
        handleServiceFieldChange("approved", value)
      }
    /> */}

                <CustomSelectBox
                  id="billing-type"
                  placeholder="Select"
                  readOnly
                  withAsterisk
                  data={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  value={
                    eligibilitystatus?.notallowed
                      ? "no"
                      : eligibilitystatus?.allowed
                      ? "yes"
                      : "no"
                  }
                  onChange={(value) =>
                    handleServiceFieldChange("approved", value)
                  }
                />
              </Box>
            </Box>

            <Box className={classes.gap}>
              {/* <Box>
              <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Approved Unit
                </Text>

                <Box className={classes.boxnumber}>
         

                  <CustomTextInput
                    // disabled={true}
                    readOnly
                    size="sm"
                    value={services?.servicechargetype}
                  />

                  <Box className={classes.line}></Box>
                  <TextInput
                    // className={classes.selecttext}
                    id="billing-name"
                    type="number"
                    size="sm"
                    placeholder={"Amount"}
                    withAsterisk
                    onChange={(e) =>
                      handleServiceFieldChange(
                        "servicechargeAmount",
                        e.target.value
                      )
                    }
                  />
                </Box>
              </Box> */}

              <Box className={classes.container}>
                <Text ff="Inter" fz={14} fw={500} color="#344054">
                  Approved Unit
                </Text>

                <Box className={classes.boxWrapper}>
                  <TextInput
                    className={classes.selectBilling}
                    rightSection={
                      <IconChevronDown color={"#94A3B8"} size={20} />
                    }
                    placeholder="Unit"
                    withAsterisk
                    variant="unstyled"
                    readOnly
                    size="sm"
                    value={services?.servicechargetype}
                  />

                  <TextInput
                    className={classes.inputField}
                    id="billing-name"
                    variant="unstyled"
                    type="number"
                    size="sm"
                    placeholder={"Amount"}
                    value={services?.servicechargeAmount || ""}
                    withAsterisk
                    onChange={(e) =>
                      handleServiceFieldChange(
                        "servicechargeAmount",
                        e.target.value
                      )
                    }
                  />
                </Box>
              </Box>

              <Box className={classes.fullw}>
                <Box className={classes.lookupflex}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Service Cost
                  </Text>
                  <Text
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setOpenLookup(true);
                    }}
                    ff={"Inter"}
                    fz={12}
                    fw={500}
                    color="#FD853A"
                  >
                    Lookup Rates
                  </Text>
                </Box>

                {/* <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Payer Service Cost
                </Text> */}

                <CustomTextInput
                  // value={
                  //   // (Number(services?.servicechargeAmount) / Number(services?.servicechargetype) * Number(services?.servicechargeNumber)).toFixed(2) || services?.servicechargeNumber
                  //   (Number(services?.servicechargeAmount) /
                  //     Number(services?.servicechargetype)) *
                  //   Number(services?.servicechargeNumber)
                  //     ? (
                  //         (Number(services?.servicechargeAmount) /
                  //           Number(services?.servicechargetype)) *
                  //         Number(services?.servicechargeNumber)
                  //       ).toFixed(2)
                  //     : services?.servicechargeNumber || ""
                  // }

                  value={services?.servicechargeNumber}
                  // readOnly
                  onChange={(e) =>
                    handleServiceFieldChange(
                      "servicechargeNumber",
                      e.target.value
                    )
                  }
                  // onChange={(e) =>
                  //   handleServiceFieldChange(
                  //     "finalamount",
                  //     value={Number(services?.servicechargeNumber) * Number(services?.servicechargeAmount)}
                  //   )
                  // }

                  placeholder="amount"
                  size="sm"
                />
              </Box>
            </Box>

            <Box className={classes.dflex} style={{ marginTop: "16px" }}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Billing Modifier <Text component="span" fz={12} color="#98A2B3">(Optional)</Text>
                </Text>
                <CustomTextInput
                  value={services?.mod1 || ""}
                  onChange={(e) =>
                    handleServiceFieldChange("mod1", e.target.value)
                  }
                  placeholder="e.g. U1"
                  size="sm"
                />
              </Box>
            </Box>

            {/* <Box className={classes.flexend}>
  <Button
    variant="filled"
    style={{ margin: "30px" }}
    radius={"md"}
    size="md"
    color="white"
    bg={"#232323"}
    onClick={() => setIsEligibilityModalVisible(true)}
  >
    Eligibility Verfication
  </Button>
  <Button
    onClick={addService}
    variant="filled"
    style={{ marginTop: "30px", marginBottom: "30px" }}
    c={"#000"}
    radius={"md"}
    size="md"
    color="yellow"
  >
    Save
  </Button>
</Box> */}
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                marginTop: "24px",
                gap: "10px",
                marginBottom: "48px",
              }}
            >
              <Button
                type="button"
                c={"#FFF"}
                onClick={addService}
                variant="fixed"
                bg={"black"}
                radius={8}
                size="sm"
                w={"100%"}
              >
                + Add Service
              </Button>

              {/* <Button
                type="button"
                c={"#FFF"}
                onClick={() => setIsEligibilityModalVisible(true)}
                variant="light"
                bg={"black"}
                size="sm"
                w={"100%"}
              >
                Eligibility Verfication
              </Button> */}
            </Box>

            {servicesinfo.length > 0 ? (
              <>
                <Divider></Divider>

                <Box style={{ marginTop: "19px" }}>
                  <Paper
                    sx={{
                      borderRadius: "8px !important",
                      border: "1px solid #E5E5E5 !important",
                      paddingTop: "12px",
                    }}
                    withBorder
                  >
                    <Table className={classes.table} striped>
                      <thead>
                        <tr>
                          <th className={classes.tableheader}>Service Name</th>
                          <th className={classes.tableheader}>Code</th>
                          <th className={classes.tableheader}>Value Type</th>
                          <th className={classes.tableheader}>Approved Unit</th>
                          <th className={classes.tableheader}>
                            Payer Service Cost
                          </th>
                          <th className={classes.tableheader}>Modifier</th>
                          <th className={classes.tableheader}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {servicesinfo?.map((existingService, index) => (
                          <tr key={index}>
                            <td className={classes.tablepara}>
                              {existingService?.servicetitle}
                            </td>
                            <td className={classes.tablepara}>
                              {existingService?.servicenumber}
                            </td>
                            {/* <td className={classes.tablepara}>
                              {existingService?.servicechargetype || "N/A"}
                            </td> */}
                            <td className={classes.tablepara}>
                              <TextInput
                                ta={"center"}
                                className={classes.newinputbox}
                                readOnly
                                value={
                                  existingService?.servicechargetype || "N/A"
                                }
                                variant="unstyled"
                              />
                            </td>

                            {/* <td className={classes.tablepara}>
                              {existingService?.servicechargeNumber || "N/A"}
                            </td> */}

                            <td className={classes.tablepara}>
                              <TextInput
                                ta={"center"}
                                className={classes.newinputbox}
                                readOnly
                                value={
                                  existingService?.servicechargeAmount || "N/A"
                                }
                                variant="unstyled"
                              />
                            </td>

                            {/* <td className={classes.tablepara}>
                              $
                              {existingService?.servicechargeNumber &&
                              existingService?.servicechargeAmount
                                ? Number(existingService?.servicechargeNumber) *
                                  Number(existingService?.servicechargeAmount)
                                : "N/A"}
                            </td> */}

                            {/* <td className={classes.tablepara}>
                              $
                              {existingService?.servicechargeNumber &&
                              existingService?.servicechargeAmount &&
                              existingService?.servicechargetype
                                ? (
                                    (Number(
                                      existingService?.servicechargeNumber
                                    ) /
                                      (isNaN(
                                        Number(
                                          existingService?.servicechargetype
                                        )
                                      )
                                        ? 1
                                        : Number(
                                            existingService?.servicechargetype
                                          ))) *
                                    Number(existingService?.servicechargeAmount)
                                  ).toFixed(2)
                                : "N/A"}
                            </td> */}

                            <td className={classes.tablepara}>
                              <TextInput
                                ta={"center"}
                                className={classes.newinputbox}
                                readOnly
                                // value={
                                //   existingService?.servicechargeNumber &&
                                //   existingService?.servicechargeAmount &&
                                //   existingService?.servicechargetype
                                //     ? `$${(
                                //         (Number(
                                //           existingService?.servicechargeNumber
                                //         ) /
                                //           (isNaN(
                                //             Number(
                                //               existingService?.servicechargetype
                                //             )
                                //           )
                                //             ? 1
                                //             : Number(
                                //                 existingService?.servicechargetype
                                //               ))) *
                                //         Number(
                                //           existingService?.servicechargeAmount
                                //         )
                                //       ).toFixed(2)}`
                                //     : "N/A"
                                // }

                                value={existingService.servicechargeNumber}
                                variant="unstyled"
                              />
                            </td>

                            <td className={classes.tablepara}>
                              {existingService?.mod1 || "-"}
                            </td>

                            <td>
                              <Button
                                className={classes.close}
                                onClick={() => removeServices(index)}
                                color="red"
                                variant="light"
                              >
                                Remove
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Paper>
                </Box>
              </>
            ) : null}
          </>
        );

      case 2:
        return (
          <>
            {/* <Text
              style={{ marginBottom: "9px" }}
              ff={"Inter"}
              fz={12}
              fw={500}
              color="#000"
            >
              Client Diagnosis Details
            </Text> */}

            <Box className={classes.searchbox}>
              <BillingSearchBar
                placeholder="Search diagnos name..."
                data={(alldiagnosiscode &&
                alldiagnosiscode.diagnosiscode &&
                diagnosisSearchValue
                  ? alldiagnosiscode.diagnosiscode
                  : []
                ).map((item) => ({
                  value: item,
                  label: item?.shortdescription,
                  key: item?.code,
                }))}
                onChange={(item) => {
                  typeof item === "string" && item && getdiagnosiscode(item);
                  setDiagnosisField({
                    code: item?.code,
                    name: item?.shortdescription,
                  });
                }}
                value={
                  typeof diagnosisSearchValue === "string"
                    ? diagnosisSearchValue
                    : diagnosisSearchValue?.shortdescription
                }
                setValue={setDiagnosisSearchValue}
              />
            </Box>
            <Box className={[classes.formRow]}>
              <Box className={classes.widthbox}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Diagnosis Name
                </Text>
                <CustomTextInput
                  name="code"
                  readOnly
                  size="sm"
                  value={diagnosisField?.name}
                  onChange={(e) => handleChange("name", e)}
                />
              </Box>

              <Box className={classes.widthbox}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Diagnosis ID
                </Text>
                <CustomTextInput
                  name="code"
                  readOnly
                  size="sm"
                  value={diagnosisField?.code}
                  onChange={(e) => handleChange("code", e)}
                />
                {/* <CustomSelectBox
                id="billing-type"
                placeholder={"Type"}
                withAsterisk
                required
                data={(alldiagnosiscode && alldiagnosiscode.diagnosiscode
                  ? alldiagnosiscode.diagnosiscode
                  : []
                ).map((item) => ({
                  value: item?.code,
                  label: item?.code,
                }))}
                // name="code"
                limit={5}
                // data={largeData}
                searchable
                //onChange={handleChange}
                onChange={(value) => handleChange("code", value)}

                //  onChange={(e) =>
                //   handleChange("code", e.target.value)
                //}
                // {...form.getInputProps("serviceCode")}
              /> */}
              </Box>

              {/* <Button
              // onClick={nextbtn}
              onClick={() => handleChangeDiagnosis()}
              variant="filled"
              c={"#000"}
              mt={37}
              radius={"md"}
              size="md"
              color="yellow"
            >
              Save
            </Button> */}
            </Box>
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "24px",
                marginBottom: "48px",
              }}
            >
              <Button
                type="button"
                c={"#FFF"}
                onClick={() => handleChangeDiagnosis()}
                variant="fixed"
                bg={"black"}
                size="sm"
                w={"100%"}
              >
                + Add
              </Button>
            </Box>
            {/* 
            <Box style={{ marginTop: "19px" }}>
              {diagnosis?.map((value, index) => (
                <Group key={index} className="tags">
                  <Box>
                    <Text  ff={"Inter"} fz={14} fw={500} color="#344054">
                      Diagnosis Name
                    </Text>
                    <CustomTextInput
                      name="code"
                      disabled={true}
                      size="sm"
                      value={value.name}
                    />
                  </Box>

                  <Box>
                    <Text  ta="center" ff={"Inter"} fz={14} fw={500} color="#344054">
                      Diagnosis ID*
                    </Text>
                    <CustomTextInput
                      name="code"
                      disabled={true}
                      size="sm"
                      value={value?.code}
                    />
                  </Box>

                  <Box>
                  <Text  ta="center" ff={"Inter"} fz={14} fw={500} color="#344054">
                Action
                    </Text>

                  <Button
                    className={classes.close}
                    onClick={() => removeDiagnosis(index)}
                    color="red"
                    variant="light"
                  >
                    Remove
                    <IconTrash size={24} />
                  </Button>
                  </Box>

                </Group>
              ))}
            </Box> */}

            {diagnosis?.length > 0 ? (
              <>
                <Divider></Divider>

                <Box style={{ marginTop: "19px" }}>
                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}> */}
                  <Paper
                    sx={{
                      borderRadius: "8px !important",
                      border: "1px solid #E5E5E5 !important",
                      padding: "26px 0px 14px 0px",
                    }}
                    withBorder
                  >
                    <Table className={classes.table} striped>
                      <thead>
                        <tr>
                          <th
                            className={classes.tableheader}
                            // style={{
                            //   textAlign: "center",
                            //   padding: "10px",
                            //   borderBottom: "2px solid #ddd",
                            // }}
                          >
                            Diagnosis Name
                          </th>
                          <th
                            className={classes.tableheader}
                            // style={{
                            //   textAlign: "center",
                            //   padding: "10px",
                            //   borderBottom: "2px solid #ddd",
                            // }}
                          >
                            Diagnosis ID
                          </th>
                          <th
                            className={classes.tableheader}
                            // style={{
                            //   textAlign: "center",
                            //   padding: "10px",
                            //   borderBottom: "2px solid #ddd",
                            // }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {diagnosis?.map((value, index) => (
                          <tr key={index}>
                            <td className={classes.tablepara}>
                              {value.name}
                              {/* <CustomTextInput
              name="code"
              readOnly
              size="sm"
              value={value.name}
            /> */}
                            </td>
                            <td className={classes.tablepara}>
                              {value?.code}
                              {/* <CustomTextInput
              name="code"
              readOnly
              size="sm"
              value={value?.code}
            /> */}
                            </td>
                            <td className={classes.tablepara}>
                              <Button
                                className={classes.close}
                                onClick={() => removeDiagnosis(index)}
                                color="red"
                                variant="light"
                              >
                                Remove
                                {/* <IconTrash size={24} /> */}
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Paper>
                </Box>
              </>
            ) : null}
          </>
        );

      case 3:
        return (
          <form onSubmit={form.onSubmit((values) => onSave(values))}>
            <div className={classes.formRow}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured First Name
                </Text>
                <CustomTextInput
                  id="first-name"
                  size="sm"
                  // value={insuranceData.firstName}
                  // // onChange={handleInsuranceChange}

                  // onChange={(e) =>
                  //   handleInsuranceChange("firstName", e.target.value)
                  // }
                       {...form.getInputProps("insurancefirstName")}
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured Middle Name
                </Text>
                <CustomTextInput
                  id="middle-name"
                  size="sm"
                  // value={insuranceData.middleName}
                  // // onChange={handleInsuranceChange}
                  // onChange={(e) =>
                  //   handleInsuranceChange("middleName", e.target.value)
                  // }
                      {...form.getInputProps("insurancemiddleName")}
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured Last Name
                </Text>
                <CustomTextInput
                  id="last-name"
                  size="sm"
                  // value={insuranceData.lastName}
                  // // onChange={handleInsuranceChange}
                  // onChange={(e) =>
                  //   handleInsuranceChange("lastName", e.target.value)
                  // }
                        {...form.getInputProps("insurancelastName")}
                />
              </Box>
            </div>

            <Box className={classes.mt19}>
              <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                Insured Address 1
              </Text>
              <CustomTextInput
                id="address1"
                size="sm"
                // value={insuranceData.address1}
                // // onChange={handleInsuranceChange}
                // onChange={(e) =>
                //   handleInsuranceChange("address1", e.target.value)
                // }
                   {...form.getInputProps("insuranceaddress1")}
              />
            </Box>

            <Box mt={10}>
              <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                Insured Address 2
              </Text>
              <CustomTextInput
                id="address2"
                size="sm"
                // value={insuranceData.address2}
                // // onChange={handleInsuranceChange}

                // onChange={(e) =>
                //   handleInsuranceChange("address2", e.target.value)
                // }
                  {...form.getInputProps("insuranceaddress2")}
              />
            </Box>

            <div style={{ marginTop: "19px" }} className={classes.formRow}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  City
                </Text>
                <CustomTextInput
                  id="city"
                  size="sm"
                  withAsterisk
                          {...form.getInputProps("insurancecity")}
                  // value={insuranceData.city}
                  // // onChange={handleInsuranceChange}
                  // onChange={(e) =>
                  //   handleInsuranceChange("city", e.target.value)
                  // }
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  State
                </Text>
                <CustomSelectBox
                  id="state"
                  size="sm"
                  withAsterisk
                  // value={insuranceData?.state}
                  data={Array.from(
                    new Set(stateZipCodes?.map((obj) => obj.ste_name))
                  ).map((ste_name) => ({
                    value: ste_name,
                    label: ste_name,
                  }))}
                  // onChange={(e) => handleInsuranceChange("state", e || "")}
                {...form.getInputProps("insurancestate")}
                  limit={10}
                  searchable
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Zip Code
                </Text>

                {/* <CustomSelectBox
                  id="zip-code"
                  type="number"
                  size="sm"
                  withAsterisk
                  value={insuranceData.zipCode}
                  disabled={!insuranceData?.state}
                  data={
                    insuranceData?.state
                      ? stateZipCodes
                          ?.filter(
                            (obj) => obj?.ste_name === insuranceData?.state
                          )
                          ?.map((obj) => ({
                            value: obj?.zip_code,
                            label: obj?.zip_code,
                          }))
                      : []
                  }
                  onChange={(e) => handleInsuranceChange("zipCode", e || "")}
                  limit={5}
                  searchable
                /> */}
  <CustomTextInput
                    id="zip-code"
                    type="number"
                    // label={"Facility Name"}
                    {...form.getInputProps("insurancezipCode")}
              
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                  />

                {/* <CustomTextInput
                  size="sm"
                  id="zip-code"
                  type="number"
                  disabled={!insuranceData?.state}
                  value={insuranceData.zipCode}
                  // onChange={handleInsuranceChange}
                  onChange={(e) => handleInsuranceChange("zipCode", e || "")}
                /> */}
              </Box>
            </div>

            <div className={classes.formRow}>
              <Box style={{ marginTop: "10px" }} className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Payer
                </Text>

                {/* <CustomSelectBox
                  id="billing-type"
                  // default={"+1"}
                  required
                  withAsterisk
                  limit={10}
                  searchable
                  value={insuranceData.payer?.value}
                  data={(allpayer && allpayer?.payer
                    ? allpayer?.payer
                    : []
                  ).map((item) => ({
                    value: item.id,
                    label: item?.payerName,
                  }))}
                  onChange={(value) => {
                    const selectedPayer = allpayer?.payer?.find(
                      (item) => item.id === value
                    );
                    //  console.log('selectedPayer',selectedPayer)
                    //  if (selectedPayer) {
                    //    setInsuranceData({
                    //      ...insuranceData,
                    //      payer: {
                    //        value: selectedPayer.id,
                    //        name: selectedPayer.payerName,
                    //      },
                    //    });
                    //  }
                    if (selectedPayer) {
                      handleInsuranceChange("payer", {
                        value: selectedPayer.id,
                        name: selectedPayer.payerName,
                      });
                    }
                  }}
                /> */}
<CustomSelectBox
  id="billing-type"
  required
  withAsterisk
  // limit={10}
  searchable
   value={form.values.insurancepayer?.value || ""} // selected payer ID

  data={(allpayer?.payer || []).map((item) => ({
    value: item.id,
    label: item.payerName,
  }))}

  onChange={(value) => {
    const selectedPayer = allpayer?.payer?.find(
      (item) => item.id === value
    );

    if (selectedPayer) {
      const payerObject = {
        value: selectedPayer.id,
        name: selectedPayer.payerName,
      };

  form.setFieldValue("insurancepayer", payerObject);
      // form.getInputProps("insurancepayer", payerObject);
    } 
  }}
/>

              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured ID Number
                </Text>
                <CustomTextInput
                  id="dob"
                  size="sm"
                  // value={insuranceData.identificationNumber}
                  // // onChange={handleInsuranceChange}
                  // onChange={(e) =>
                  //   handleInsuranceChange(
                  //     "identificationNumber",
                  //     e.target.value
                  //   )
                  // }
                      {...form.getInputProps("insuranceidentificationNumber")}
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured Group ID
                </Text>
                <CustomTextInput
                  id="dob"
                  size="sm"
                  // value={insuranceData.groupPolicyNumber}
                  // // onChange={handleInsuranceChange}
                  // onChange={(e) =>
                  //   handleInsuranceChange("groupPolicyNumber", e.target.value)
                  // }
                    {...form.getInputProps("insurancegroupPolicyNumber")}
                />
              </Box>
            </div>

            <div className={classes.formRow}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured DOB
                </Text>

                {/* <CustomTextInput
                   id="dob"
                   size="sm"
                   withAsterisk
                   value={insuranceData.dob}
                   onChange={(e) =>
                     handleInsuranceChange("dob", e?.target?.value)
                   }
                 /> */}
                <DatePickerInput
                  id="dob"
                  sx={{
                    "& .mantine-1e6hn20": {
                      border: "none",
                      minHeight: "fit-content !important",
                    },

                    "& .mantine-1d4lrir": {
                      border: "none !important",
                    },
                  }}
                  // defaultDate={Date.now()}
                 // value={insuranceData.dob ||new Date() }
                  className={classes.datepickerinput}
               
                  
                  // size="xl"
                  placeholder="mm/dd/yyyy"
                  icon={
                    <img
                      style={{ width: "20px" }}
                      src={"/assets/images/billingcalendar.png"}
                      alt="Icon"
                    />
                  }
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  // onChange={(e) =>
                  //   handleInsuranceChange("dob", e?.target?.value)
                  // }
                   {...form.getInputProps("insurancedob")}
                  //onChange={(value) => handleInsuranceChange("dob", value)}
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Authorization #
                </Text>

                <CustomTextInput
                  id="dob"
                  size="sm"
                  withAsterisk
                      {...form.getInputProps("insuranceauthorization")}
                  // value={insuranceData.authorization}
                  // onChange={(e) =>
                  //   handleInsuranceChange("authorization", e?.target?.value)
                  // }
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Authorization End Date
                </Text>

                {/* <CustomTextInput
                  value={insuranceData.authorizationEndDate}
                   id="dob"
                   size="sm"
                   withAsterisk
                   onChange={(e) =>
                     handleInsuranceChange("authorizationEndDate", e?.target?.value)
                   }
                 /> */}

                <DatePickerInput
                      id="insuranceauthorizationEndDate"
                  // defaultDate={Date.now()}
                  sx={{
                    "& .mantine-1e6hn20": {
                      border: "none",
                      minHeight: "fit-content !important",
                    },

                    "& .mantine-1d4lrir": {
                      border: "none !important",
                    },
                  }}
                  // value={insuranceData?.authorizationEndDate ||new Date() }
                  className={classes.datepickerinput}
                  //defaultDate={Date.now()}
                  //  defaultValue={new Date()}
                  // size="xl"
                  placeholder="mm/dd/yyyy"
                  icon={
                    <img
                      style={{ width: "20px" }}
                      src={"/assets/images/billingcalendar.png"}
                      alt="Icon"
                    />
                  }
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  // onChange={(e) =>
                  //   handleInsuranceChange("dob", e?.target?.value)
                  // }
                  // onChange={(value) =>
                  //   handleInsuranceChange("authorizationEndDate", value)
                  // }
                  {...form.getInputProps("insuranceauthorizationEndDate")}
                />
              </Box>
            </div>

            <div className={classes.formRow}>
              <Box>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Gender
                </Text>
                <CustomSelectBox
                  id="gender"
                  placeholder="Select"
                  // value={insuranceData.gender}
                  // onChange={handleInsuranceChange}

                  data={[
                    { value: "Male", label: "male" },
                    { value: "Female", label: "female" },
                  ]}
                  // onChange={(e) => handleInsuranceChange('gender', e.target.value)}
                  // onChange={(value) => handleInsuranceChange("gender", value)}
                  {...form.getInputProps("insurancegender")}
                />
              </Box>

              <Box style={{ width: "61%" }}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured Relationship
                </Text>
                <CustomSelectBox
                  id="gender"
                  placeholder="Select"
                  data={[
                    { value: "18", label: "self" },
                    { value: "1", label: "spouse" },
                    { value: "19", label: "child" },
                    { value: "G8", label: "other" },
                  ]}
                       {...form.getInputProps("insurancerelationshipToInsured")}
                  // value={insuranceData.relationshipToInsured}
                  // // onChange={handleInsuranceChange}
                  // onChange={(value) =>
                  //   handleInsuranceChange("relationshipToInsured", value)
                  // }
                />
              </Box>
            </div>

            {/* <Box style={{ marginTop: "19px" }}>
               {insuranceArray?.map((value, index) => (
                 <Group
                   key={index}
                   className="tags"
                   style={{ marginBottom: 10 }}
                 >
                   <Badge color="#6C63FF1A" radius="xs" size="lg">
                     {value.firstName}
                   </Badge>
 
                   <Group>
               
                     <ActionIcon
                       onClick={() => moveUp(index)}
                       disabled={index === 0}
                     >
                       <AiOutlineArrowUp size={18} />
                     </ActionIcon>
 
                     <ActionIcon
                       onClick={() => moveDown(index)}
                       disabled={index === insuranceArray.length - 1}
                     >
                       <AiOutlineArrowDown size={18} />
                     </ActionIcon>
                   </Group>
 
          
                   <Button
                     className={classes.close}
                     onClick={() => removeInsurance(index)}
                     color="red"
                     variant="light"
                   >
                     Remove
                   </Button>
                 </Group>
               ))}
             </Box> */}

            {/* <Text>Please Select Only 1 insurance for creating Claims</Text> */}

            {/* <Box style={{ display: "flex", justifyContent: "flex-end" }}>
               <Button
                 onClick={handleInsuranceSubmit}
                 variant="filled"
                 c="#FFF"
                 radius="md"
                 size="md"
                 color="yellow"
               >
                 Save
               </Button>
             </Box> */}

            <Box className={classes.addbtn}>
              {/* <Button
                 // onClick={onSave}
                 type="submit"
                 variant="filled"
                 c="#FFF"
                 radius="md"
                 size="md"
                 color="#387ED1"
               >
                 + Add New Client
               </Button> */}

              <Button
                // classNames={classes.button}
                // onClick={() => {
                //   setCurrentStep(currentStep - 1);
                // }}
                size="md"
                onClick={handleClose}
                variant="fixed"
                radius={8}
                style={{ border: "1px solid #D0D5DD" }}
                // className={classes.backNextBtn}
                c="#1D2939"
                color="white"
              >
                Cancel
              </Button>

              <Button
                // onClick={onSave}
                disabled={isPreview}
                type="submit"
                variant="filled"
                c="#000"
                radius={8}
                size="md"
                color="yellow"
              >
                Submit
              </Button>
            </Box>
          </form>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    //getServicecode()
    getAllPatientsModal();
  }, []);

  return (
    <>
      <Drawer
        shadow="md"
        size="45%"
        sx={{
          ".mantine-1fholi4": {
            color: "#000",
          },
          ".mantine-1ddebd9": {
            background: "#F5F5F5",
          },
          ".mantine-1fholi4:hover": {
            color: "#FFAF4A",
          },
          ".mantine-1q36a81": {
            padding: "0",
          },
        }}
        title={
          <span style={{ fontSize: "24px", fontWeight: "700", color: "#000" }}>
            Edit Client
          </span>
        }
        radius={"lg"}
        zIndex={1000}
        centered
        opened={editclient}
        onClose={handleClose}
        position="right"
        scrollAreaComponent={ScrollArea.Autosize}
        overlayProps={{ backgroundOpacity: 2.5, blur: 4 }}
        // title="Edit Client"
        styles={{
          title: {
            color: "#000",
            fontWeight: "bold",
            fontSize: "24px",
            fontWeight: "700",
          },
        }}
      >
        <Box className={classes.mainbox}>
          <Box className={classes.stepsclient}>
            <Box style={{ cursor: "pointer" }} onClick={() => updatestate(0)}>
              <Text ff={"Inter"} fz={14} fw={500} ta="center" color="#3F3F46">
                1
              </Text>
              <Text
                style={{
                  marginTop: "12px",
                  borderBottom: currentStep === 0 ? "2px solid #000" : "none",
                }}
                ff={"Inter"}
                ta="center"
                fz={14}
                fw={500}
                color="#3F3F46"
              >
                Client Personal Data
                {selectedProvider && facility?.length > 0 && currentStep > 0 ? (
                  <img
                    width={30}
                    style={{ position: "relative", left: "10px" }}
                    src="/assets/images/Check icon.png"
                    alt="check-icon"
                  />
                ) : null}
              </Text>
            </Box>

            <Box style={{ cursor: "pointer" }} onClick={() => updatestate(1)}>
              <Text ta="center" ff={"Inter"} fz={14} fw={500} color="#3F3F46">
                2
              </Text>
              <Text
                style={{
                  marginTop: "12px",
                  borderBottom: currentStep === 1 ? "2px solid #000" : "none",
                }}
                ff={"Inter"}
                fz={14}
                ta="center"
                fw={500}
                color="#3F3F46"
              >
                Client Service Details
                {servicesinfo.length > 0 && currentStep > 1 ? (
                  <img
                    width={30}
                    style={{ position: "relative", left: "10px" }}
                    src="/assets/images/Check icon.png"
                    alt="check-icon"
                  />
                ) : null}
              </Text>
            </Box>

            <Box style={{ cursor: "pointer" }} onClick={() => updatestate(2)}>
              <Text ta="center" ff={"Inter"} fz={14} fw={500} color="#3F3F46">
                3
              </Text>
              <Text
                ta="center"
                style={{
                  marginTop: "12px",
                  borderBottom: currentStep === 2 ? "2px solid #000" : "none",
                }}
                ff={"Inter"}
                fz={14}
                fw={500}
                color="#3F3F46"
              >
                Diagnosis
                {diagnosis.length > 0 && currentStep > 2 ? (
                  <img
                    width={30}
                    style={{ position: "relative", left: "10px" }}
                    src="/assets/images/Check icon.png"
                    alt="check-icon"
                  />
                ) : null}
              </Text>
            </Box>

            <Box style={{ cursor: "pointer" }} onClick={() => updatestate(3)}>
              <Text ta="center" ff={"Inter"} fz={14} fw={500} color="#3F3F46">
                4
              </Text>
              <Text
                ta="center"
                style={{
                  marginTop: "12px",
                  borderBottom: currentStep === 3 ? "2px solid #000" : "none",
                }}
                ff={"Inter"}
                fz={14}
                fw={500}
                color="#3F3F46"
              >
                Client Insurance Details
                {insuranceArray.length > 0 && currentStep > 3 ? (
                  <img
                    width={30}
                    style={{ position: "relative", left: "10px" }}
                    src="/assets/images/Check icon.png"
                    alt="check-icon"
                  />
                ) : null}
              </Text>
            </Box>
          </Box>

          <Text
            style={{ marginBottom: "9px" }}
            ff={"Inter"}
            fz={14}
            fw={500}
            color="#171717"
          >
            {currentStep === 0 && "Client Personal Details"}
            {currentStep === 1 && "Client Service Details"}
            {currentStep === 2 && "Diagnosis"}
            {currentStep === 3 && "Insurance Details"}
          </Text>

          <Box className={classes.addbox}>{renderContent()}</Box>

          <Box className={classes.dbtnflex}>
            {currentStep < 3 && (
              <Button
                // onClick={() => {
                //   setCurrentStep(currentStep - 1);
                // }}
                onClick={handleClose}
                size="md"
                variant="fixed"
                radius={8}
                style={{ border: "1px solid #D0D5DD" }}
                className={classes.backNextBtn}
                c="#1D2939"
                bg="#F9FAFB"
              >
                Cancel
              </Button>
            )}

            {currentStep <= 2 && (
              <Button
                onClick={nextbtn}
                variant="filled"
                c={"#000"}
                radius={8}
                size="md"
                color="yellow"
                className={classes.backNextBtn}
              >
                Next
              </Button>
            )}
          </Box>
        </Box>

        {/* <CheckEligibilty
          state={isEligibilityModalVisible}
          setState={setIsEligibilityModalVisible}
          selectedData={{
            provider: provider?.id,
            payer: patient?.payer,
            client: {
              firstName: form?.values?.firstName || "",
              lastName: form?.values?.lastName || "",
              relationshipToInsured:
                insuranceData?.relationshipToInsured || "18",
            },
          }}
        /> */}
        <ProviderServicesLookupModal
          openlookup={openlookup}
          setOpenLookup={setOpenLookup}
        />
      </Drawer>
    </>
  );
}

export default EditClient;
